var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRelationLeft = function SvgRelationLeft(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 50,
    viewBox: "0 0 24 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14C11 12.3431 12.3431 11 14 11H21C21.5523 11 22 11.4477 22 12V12C22 12.5523 21.5523 13 21 13H14C13.4477 13 13 13.4477 13 14V36C13 36.5523 13.4477 37 14 37H21C21.5523 37 22 37.4477 22 38V38C22 38.5523 21.5523 39 21 39H14C12.3431 39 11 37.6569 11 36V14Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3018,
    cy: 38,
    r: 2.69819,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4095 13.4142L19.874 16.9497C19.4834 17.3403 18.8503 17.3403 18.4597 16.9497V16.9497C18.0692 16.5592 18.0692 15.9261 18.4597 15.5355L20.5811 13.4142C21.3621 12.6332 21.3621 11.3668 20.5811 10.5858L18.4597 8.46447C18.0692 8.07394 18.0692 7.44078 18.4597 7.05025V7.05025C18.8503 6.65973 19.4834 6.65973 19.874 7.05025L23.4095 10.5858V10.5858C24.1905 11.3668 24.1905 12.6332 23.4095 13.4142V13.4142Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRelationLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "relation-left.3b59a17dbcddb2cefefa447df82aaccb.svg";